import {
  FaqItem,
  FaqSection,
  FaqPanelProps,
} from "../../../ui/organisms/FaqPanel/types"

const toFaqItem = (item: any): FaqItem => ({
  title: item.title,
  slug: item.slug?.current,
  content: item.content,
})

const toFaqSection = (section: any, index: number): FaqSection => ({
  title: section.title,
  slug: section.slug?.current,
  items: section.items?.map(toFaqItem),
  id: index.toString(),
})

export const toFaqPanelProps = (item: any): Omit<FaqPanelProps, "query"> => ({
  title: item.data?.title,
  sections: item.data?.sections?.map(toFaqSection) ?? [],
})
